import React from 'react';
import { Pill } from './Pill';
interface SectionHeadingProps {
  eyebrow?: string;
  eyebrowTone?: 'accent' | 'danger' | 'outline';
  title: React.ReactNode;
  lead?: React.ReactNode;
  align?: 'center' | 'left';
  className?: string;
}
export function SectionHeading({
  eyebrow,
  eyebrowTone = 'accent',
  title,
  lead,
  align = 'center',
  className = ''
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'mx-auto max-w-4xl text-center' : 'max-w-4xl';
  return <div className={`${alignment} ${className}`} data-id="element-215" data-mp="gj6uf9x23bif">
      {eyebrow ? <Pill tone={eyebrowTone} data-id="element-216" data-mp="gion9i8uvcvq">{eyebrow}</Pill> : null}
      <h2 className={`text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-slate-50 sm:text-4xl lg:text-5xl [.chalk_&]:text-slate-900 ${eyebrow ? 'mt-3' : ''}`} data-id="element-217" data-mp="1vc0jq7bb13r">
        {title}
      </h2>
      {lead ? <p className={`mt-3 text-lg leading-relaxed text-slate-400 [.chalk_&]:text-slate-600 ${align === 'center' ? 'mx-auto max-w-2xl' : 'max-w-2xl'}`} data-id="element-218" data-mp="ui6h4c10dgby">
          {lead}
        </p> : null}
    </div>;
}